import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import moment from "moment";
import { httpGet, httpPost } from "../../services/httpService";
import setClinicalChecks from "../../Model/ClinicalChecks/setClinicalChecks";
import {
  getPrescriptionIncomingIdsUrl,
  getPrescriptionByIncomingIdUrl,
  getMedicationUrl,
  getPrescriptionItemChecksUrl,
  getPrescriptionChecksUrl,
  postMedicationUrl,
  getAdditionalEndorsementUrl,
  setPatientClinicalChecksUrl,
  getPatientImageUrl,
  postItemToolTipUrl,
  updateItemToolTipUrl,
  addpatientInTitanUrl,
  getDrugUomFixValueUrl,
  getTitanPatientSearchUrl,
  addEmergencySuppliesUrl,
  updateItemToolTipFlavoursUrl,
  getKanbanInboxUrl,
  getKanbanCheckUrl,
  getTitanPatientByPatientIDUrl,
  getClinicalChecksTags,
  setPatientTagsUrl,
  lockedPrescriptionsUrl,
  updatePrescriptionPositionUrl,
  updateBucketStatusUrl,
  deletePatientTagUrl,
  getPatientHistoryUrl,
  getPatientLastDosageUrl,
} from "../../apiUrls/apiUrls";
import { logErrorWithPayload } from "../../services/logService";

var curr = new Date();
curr.setDate(curr.getDate() + 3);
var date = curr.toISOString().substring(0, 10);

const initialState = {
  isChecksLoading: false,
  isNmsPrescriptionLoading: false,
  isClinicalChecksImageLoading: false,
  medicationId: false,
  isSkip: false,
  isMatched: false,
  isAccess: false,
  isMandatory: false,
  isTherapy: false,
  isEndorse: false,
  returnReport: false,
  isReturnDispense: false,
  isEditable: false,
  buttonClass: false,
  isPatient: false,
  severityCount: 0,
  incomingId: "",
  patientId: "",
  patientName: "",
  itemReturnDose: "",
  itemReturnQuantity: 0,
  returnQuantity: 0,
  returnDose: "",
  returnDispense: "",
  returnMarking: "",
  returnColor: "Green",
  returnStartDate: date,
  returnStopDate: date,
  returnTherapy: 0,
  returnPreparation: 0,
  returnArchive: false,
  dispenseArray: [],
  medicineWarning: [],
  incomingIds: [],
  prescriptions: [],
  clinicalChecksPharmacy: [],
  itemChecks: [],
  patientMedication: null,
  prescriptionItemCheck: [],
  prescriptionChecks: [],
  clinicalChecksNotes: [],
  therapyComponents: [],
  defaultDosageTimings: [],
  medicationTime: [],
  prescriptionCheckGroups: [],
  postMedication: [],
  postMedicationId: null,
  additionalEndorsement: [],
  notesModel: [],
  clinicalHeaderNotesModel: [],
  patientImage: [],
  checkNowModel: null,
  clinicalChecksAdded: null,
  patientTag: [],
  newPatientId: "",
  isParked: false,
  isCCOrderTooltipLoading: false,
  prescriptionItemToolTip: [],
  CCOrderTooltipData: null,
  toolTipSummaryData: [],
  updateCCOrderTooltipLoading: false,
  selectedBucketType: 3,
  isTherapyModal: false,
  therapyModelContents: null,
  isPatientAddedInTitan: false,
  prescribedItemInfoModel: null,
  uom: [],
  patientSearchLoader: false,
  patientSearchItems: [],
  openFindPatientModal: false,
  openFindPatientComparisonModal: false,
  emergencySupplies: [],
  isCCModalOpen: false,
  CCModalLoader: false,
  kanbanInbox: [],
  KanbanChecks: [],
  isCCKanbanLoading: false,
  patientData: null,
  checkedClinicalId: [],
  lastOrderedQuantity: 0,
  filterNameValues: "",
  clinicalChecksTags: [],
  lockedPrescriptions: null,
  isTagsLoading: false,
  isHasDispensingWindow: false,
  isAccepted: false,
  clinicalCheckPosition: false,
  clinicalCheckStatus: false,
  checksTagsfilters: [],
  clinicalCheckPatientTags: [],
  showNoPatientInTitanPopup: false,
  isHistoryLoading: false,
  patientHistory: [],
  isDoseValue: false,
  doseValueTotalEmpty: 0,
  doseValueEmptyPrescribedItemId: [],
  kanbanFilters: {
    filterNMSValueDropdown: "Is",
    filterTagValuesCheck: [],
  },
  isLastDosageLoading: false,
  patientTagsColor: [],
};
// const validationChecks = [11, 18, 100, 9, 7, 8];
const validationChecks = [18, 100];
const therapyChanges = [44, 45, 46, 47, 48];

export const getPrescriptionIncomingIdsData = createAsyncThunk(
  "clinicalChecks/getPrescriptionIncomingIdsData",
  async (params) => {
    const { pharmacyId, currentTeamId } = params || {
      pharmacyId: "00000000-0000-0000-0000-000000000000",
    };
    const respData = await httpGet(
      getPrescriptionIncomingIdsUrl(pharmacyId, currentTeamId),
    );
    return respData;
  },
);

export const getPrescriptionByIncomingIdData = createAsyncThunk(
  "clinicalChecks/getPrescriptionByIncomingIdData",
  async (params) => {
    const { prescriptionIncomingId, pharmacyID } = params || {};
    const respData = await httpGet(
      getPrescriptionByIncomingIdUrl(prescriptionIncomingId, pharmacyID),
    );
    return respData;
  },
);

export const getMedicationData = createAsyncThunk(
  "clinicalChecks/getMedicationData",
  async (params) => {
    const { patientId, pharmacyID } = params || {};
    const respData = await httpGet(
      getMedicationUrl(
        patientId === null ? "00000000-0000-0000-0000-000000000000" : patientId,
        pharmacyID,
      ),
    );
    return respData;
  },
);
export const getAdditionalEndorsementData = createAsyncThunk(
  "clinicalChecks/getAdditionalEndorsementData",
  async (params) => {
    const { PrescribedItemId, pharmacyID } = params || {};
    const respData = await httpGet(
      getAdditionalEndorsementUrl(PrescribedItemId, pharmacyID),
    );
    return respData;
  },
);
export const getPatientImageData = createAsyncThunk(
  "clinicalChecks/getPatientImageData",
  async (params) => {
    const { imageValue, pharmacyID } = params || {};
    const respData = await httpGet(getPatientImageUrl(imageValue, pharmacyID));
    return respData;
  },
);

export const setPatientClinicalChecksData = createAsyncThunk(
  "clinicalChecks/setPatientClinicalChecksData",
  async (params) => {
    const { checkNowModel, pharmacyID } = params || {};
    const respData = await httpPost(
      setPatientClinicalChecksUrl(pharmacyID),
      checkNowModel,
    );
    return respData;
  },
);
export const getPrescriptionItemChecksData = createAsyncThunk(
  "clinicalChecks/getPrescriptionItemChecksData",
  async (params) => {
    const { prescriptionItemChecksBody, pharmacyID } = params || {};
    const respData = await httpPost(
      getPrescriptionItemChecksUrl(pharmacyID),
      prescriptionItemChecksBody,
    );
    return respData;
  },
);
export const getPrescriptionChecksData = createAsyncThunk(
  "clinicalChecks/getPrescriptionChecksData",
  async (params) => {
    const { prescriptionCheckBody, pharmacyID } = params || {};
    const respData = await httpPost(
      getPrescriptionChecksUrl(pharmacyID),
      prescriptionCheckBody,
    );
    return respData;
  },
);
export const addEmergencySuppliesData = createAsyncThunk(
  "clinicalChecks/addEmergencySuppliesData",
  async (params) => {
    const { pharmacyID, patientID, prescribedItemID } = params || {};
    const respData = await httpGet(
      addEmergencySuppliesUrl(pharmacyID, patientID, prescribedItemID),
    );
    return respData;
  },
);
export const getPostMedicationData = createAsyncThunk(
  "clinicalChecks/getPostMedicationData",
  async (params) => {
    const { prescriptionCheckBody, pharmacyID } = params || {};
    const respData = await httpPost(
      postMedicationUrl(pharmacyID),
      prescriptionCheckBody,
    );
    return respData;
  },
);

export const setCCOrderItemToolTipData = createAsyncThunk(
  "clinicalChecks/setCCOrderItemToolTipData",
  async (params) => {
    const { CCOrderTooltipBody, pharmacyID } = params || {};
    const respData = await httpPost(
      postItemToolTipUrl(pharmacyID),
      CCOrderTooltipBody,
    );
    return respData;
  },
);

export const updateCCOrderItemToolTipData = createAsyncThunk(
  "clinicalChecks/updateCCOrderItemToolTipData",
  async (params) => {
    const { CCUpdateOrderTooltipBody, pharmacyID } = params || {};
    const respData = await httpPost(
      updateItemToolTipUrl(pharmacyID),
      CCUpdateOrderTooltipBody,
    );
    return respData;
  },
);

export const updateItemToolTipFlavoursData = createAsyncThunk(
  "clinicalChecks/updateItemToolTipFlavoursData",
  async (params) => {
    const { orderToolTipsFlavours, pharmacyID } = params || {};
    const respData = await httpPost(
      updateItemToolTipFlavoursUrl(pharmacyID),
      orderToolTipsFlavours,
    );
    return respData;
  },
);

export const addpatientInTitanData = createAsyncThunk(
  "clinicalChecks/addpatientInTitanData",
  async (params) => {
    const { patientAddBody, pharmacyID } = params || {};
    const respData = await httpPost(
      addpatientInTitanUrl(pharmacyID),
      patientAddBody,
    );
    return respData;
  },
);
export const updateBucketStatusData = createAsyncThunk(
  "/clinicalChecks/update-bucket-status",
  async (params) => {
    const { pharmacyID, batchId, prescriptionIncomingId, bucketStatus } =
      params || {};
    const respData = await httpPost(
      updateBucketStatusUrl(
        pharmacyID,
        batchId,
        prescriptionIncomingId,
        bucketStatus,
      ),
    );
    return respData;
  },
);
export const updateBucketPositionData = createAsyncThunk(
  "clinicalChecks/update-prescription-position",
  async (params) => {
    const { bucketStatusBody, pharmacyID } = params || {};
    const respData = await httpPost(
      updatePrescriptionPositionUrl(pharmacyID),
      bucketStatusBody,
    );
    return respData;
  },
);

export const getDrugUomFixValueData = createAsyncThunk(
  "clinicalChecks/getDrugUomFixValueData",
  async (params) => {
    const { prescribedItemID, prescriptionOriginCountry, pharmacyID } =
      params || {
        pharmacyId: "00000000-0000-0000-0000-000000000000",
      };
    const respData = await httpGet(
      getDrugUomFixValueUrl(
        prescribedItemID,
        prescriptionOriginCountry,
        pharmacyID,
      ),
    );
    return respData;
  },
);

export const getTitanPatientSearchData = createAsyncThunk(
  "clinicalChecks/getTitanPatientSearchData",
  async (params) => {
    const { patientFindBody, pharmacyID } = params || {};
    const respData = await httpPost(
      getTitanPatientSearchUrl(pharmacyID),
      patientFindBody,
    );
    return respData;
  },
);

export const getKanbanInboxData = createAsyncThunk(
  "clinicalChecks/getKanbanInboxData",
  async (pharmacyId) => {
    const respData = await httpGet(getKanbanInboxUrl(pharmacyId));
    return respData;
  },
);
export const getKanbanCheckData = createAsyncThunk(
  "clinicalChecks/getKanbanCheckData",
  async (pharmacyId) => {
    const respData = await httpGet(getKanbanCheckUrl(pharmacyId));
    return respData;
  },
);
export const getTitanPatientByPatientIdData = createAsyncThunk(
  "clinicalChecks/getTitanPatientByPatientIdData",
  async (params) => {
    const { patientId, pharmacyID } = params || {};
    const urlToGet = getTitanPatientByPatientIDUrl(patientId, pharmacyID);
    const respData = await httpGet(urlToGet);
    return respData;
  },
);

export const getClinicalChecksTagsData = createAsyncThunk(
  "clinicalChecks/getClinicalChecksTagsData",
  async (pharmacyId) => {
    const respData = await httpGet(getClinicalChecksTags(pharmacyId));
    return respData;
  },
);

export const setPatientTagsData = createAsyncThunk(
  "clinicalChecks/setPatientTagsData",
  async (params) => {
    const { pharmacyId, patientId, tagId } = params || {};
    const respData = await httpGet(
      setPatientTagsUrl(pharmacyId, patientId, tagId),
    );
    return respData;
  },
);
export const lockedPrescriptionsData = createAsyncThunk(
  "clinicalChecks/lockedPrescriptionsData",
  async (params) => {
    const { prescriptionViewedBy, currentPharmacyId } = params || {};
    const respData = await httpPost(
      lockedPrescriptionsUrl(currentPharmacyId),
      prescriptionViewedBy,
    );
    return respData;
  },
);
export const deletePatientTagData = createAsyncThunk(
  "clinicalChecks/deletePatientTag",
  async (params, thunkAPI) => {
    const { currentPharmacyId, tagId, patientId } = params || {
      pharmacyId: "00000000-0000-0000-0000-000000000000",
    };
    // const urlToDelete = deletePatientTagUrl();
    const respData = await httpPost(
      deletePatientTagUrl(currentPharmacyId, patientId, tagId),
    );
    return respData;
  },
);
export const getPatientHistoryData = createAsyncThunk(
  "clinicalChecks/getPatientHistory",
  async (params, thunkAPI) => {
    const { currentPharmacyId, patientId, fromDate, toDate } = params || {
      pharmacyId: "00000000-0000-0000-0000-000000000000",
    };
    // Guard: patientId is not yet loaded when a date-range change fires before
    // patient data resolves. Without this the URL contains "patientID=undefined"
    // which causes a network error (confirmed in Sentry breadcrumbs).
    if (!patientId || patientId === "00000000-0000-0000-0000-000000000000") {
      return [];
    }
    const respData = await httpGet(
      getPatientHistoryUrl(currentPharmacyId, patientId, fromDate, toDate),
    );
    return respData;
  },
);

export const getPatientLastDosageData = createAsyncThunk(
  "clinicalChecks/getPatientLastDosage",
  async (params) => {
    const { pharmacyID, patientID, prescribedItemID } = params || {};
    const respData = await httpGet(
      getPatientLastDosageUrl(pharmacyID, patientID, prescribedItemID),
    );
    return respData;
  },
);
const clinicalChecksSlice = createSlice({
  name: "clinicalChecks",
  initialState,
  reducers: {
    setIsClinicalChecksLoading: (state, action) => {
      state.isChecksLoading = action?.payload || false;
    },
    setIsNmsPrescriptionLoading: (state, action) => {
      state.isNmsPrescriptionLoading = action?.payload || false;
    },
    setIsSkip: (state, action) => {
      state.isSkip = action?.payload || false;
    },
    setIsMatched: (state, action) => {
      state.isMatched = action?.payload || false;
    },
    setIsMandatory: (state, action) => {
      state.isMandatory = action?.payload || false;
    },
    setIsTheraphy: (state, action) => {
      state.isTherapy = action?.payload || false;
    },
    setIsEndorse: (state, action) => {
      state.isEndorse = action?.payload || false;
    },
    setIsSeverityCount: (state, action) => {
      state.severityCount = action?.payload || false;
    },
    setIsCheckNowModel: (state, action) => {
      state.checkNowModel = action?.payload || false;
    },
    setClinicalChecksNotes: (state, action) => {
      state.clinicalChecksNotes = action?.payload || [];
    },
    setIsDispenseArray: (state, action) => {
      state.dispenseArray = action?.payload || false;
    },
    setIsItemchecks: (state, action) => {
      state.prescriptionItemCheck = action?.payload || false;
    },
    setIsAccess: (state, action) => {
      state.isAccess = action?.payload || false;
    },
    setIsItemReturnDose: (state, action) => {
      state.itemReturnDose = action?.payload || false;
    },
    setIsItemReturnQuantity: (state, action) => {
      state.itemReturnQuantity = action?.payload || false;
    },
    setIsReturnQuantity: (state, action) => {
      state.returnQuantity = action?.payload || false;
    },
    setIsReturnDose: (state, action) => {
      state.returnDose = action?.payload || false;
    },
    setIsReturnDispense: (state, action) => {
      state.returnDispense = action?.payload || false;
    },
    setIsReturnStartDate: (state, action) => {
      state.returnStartDate = action?.payload || false;
    },
    setIsReturnStopDate: (state, action) => {
      state.returnStopDate = action?.payload || false;
    },
    setIsReturnMarking: (state, action) => {
      state.returnMarking = action?.payload || false;
    },
    setIsReturnTherapy: (state, action) => {
      state.returnTherapy = action?.payload || false;
    },
    setIsReturnPreparation: (state, action) => {
      state.returnPreparation = action?.payload || false;
    },
    setIsReturnArchive: (state, action) => {
      state.returnArchive = action?.payload || false;
    },
    setIsReturnColor: (state, action) => {
      state.returnColor = action?.payload || false;
    },
    setIsReturnReport: (state, action) => {
      state.returnReport = action?.payload || false;
    },
    setIsDispense: (state, action) => {
      state.isReturnDispense = action?.payload || false;
    },
    setIsEditable: (state, action) => {
      state.isEditable = action?.payload || false;
    },
    setIsButtonclass: (state, action) => {
      state.buttonClass = action?.payload || false;
    },
    setIsNotesModel: (state, action) => {
      state.notesModel = action?.payload || [];
    },
    setIsClinicalHeaderNotesModel: (state, action) => {
      state.clinicalHeaderNotesModel = action?.payload || [];
    },
    setMedicationTimeModel: (state, action) => {
      state.medicationTime = action?.payload || false;
    },
    setIsMedicineWarning: (state, action) => {
      state.medicineWarning = action?.payload || false;
    },
    setIsPatientImage: (state, action) => {
      state.patientImage = action?.payload || false;
    },
    setIsMedicationId: (state, action) => {
      state.medicationId = action?.payload || false;
    },
    setIsParkedData: (state, action) => {
      state.isParked = action?.payload || false;
    },
    setSelectedBucketTypeData: (state, action) => {
      state.selectedBucketType = action?.payload || 3;
    },
    setIsTheraphyModal: (state, action) => {
      state.isTherapyModal = action?.payload || false;
    },
    setTherapyModelContent: (state, action) => {
      state.therapyModelContents = action?.payload;
    },
    setOpenFindPatientModalData: (state, action) => {
      state.openFindPatientModal = action?.payload;
    },
    setOpenFindPatientComparisonModalData: (state, action) => {
      state.openFindPatientComparisonModal = action?.payload;
    },
    setCCModalOpenData: (state, action) => {
      state.isCCModalOpen = action?.payload || false;
    },
    setCCModalLoaderData: (state, action) => {
      state.CCModalLoader = action?.payload || false;
    },
    setPrescriptionItemToolTip: (state, action) => {
      state.prescriptionItemToolTip = action?.payload || [];
    },
    setIsCCKanbanLoadingData: (state, action) => {
      state.isCCKanbanLoading = action?.payload || false;
    },
    setisHasDispensingWindow: (state, action) => {
      state.isHasDispensingWindow = action?.payload || false;
    },
    setIsAcceptedData: (state, action) => {
      state.isAccepted = action?.payload || false;
    },
    setIsPatientData: (state, action) => {
      state.isPatient = action?.payload || false;
    },
    setPatientDataData: (state, action) => {
      state.patientData = action?.payload || null;
    },
    setClinicalCheckPositionData: (state, action) => {
      state.clinicalCheckPosition = action?.payload || null;
    },
    setClinicalCheckStatusData: (state, action) => {
      state.clinicalCheckStatus = action?.payload || null;
    },
    setIsCheckedClinicalId: (state, action) => {
      if (action.payload === null) {
        state.checkedClinicalId = [];
      } else {
        state.checkedClinicalId = [...state.checkedClinicalId, action.payload];
      }
    },
    setShowNoPatientInTitanPopupData: (state, action) => {
      state.showNoPatientInTitanPopup = action?.payload || null;
    },
    setIsClinicalChecksPatientTags: (state, action) => {
      state.clinicalCheckPatientTags = action?.payload || [];
    },
    setKanbanInbox: (state, action) => {
      state.kanbanInbox = action?.payload || [];
    },
    setKanbanChecks: (state, action) => {
      state.KanbanChecks = action?.payload || [];
    },
    setPatientHistory: (state, action) => {
      state.patientHistory = action?.payload || [];
    },
    setFilterNamevalues: (state, action) => {
      state.filterNameValues = action?.payload || [];
    },
    updateFlavourQuantity: (state, action) => {
      const { stockItemId, quantity } = action.payload;
      //check for index before proceeding
      const correctIndex = state.prescriptionItemToolTip.findIndex((tooltip) =>
        tooltip?.orderTooltipSummaryItemWithFlavours?.some(
          (item) => item.stockItemId === stockItemId,
        ),
      );

      if (correctIndex !== -1) {
        const items =
          state.prescriptionItemToolTip[correctIndex]
            .orderTooltipSummaryItemWithFlavours;
        const itemIndex = items.findIndex(
          (item) => item.stockItemId === stockItemId,
        );

        if (itemIndex !== -1) {
          items[itemIndex].numberOfPacks = quantity;
        }
      }
    },

    updateFlavourOrderTrolleyProfileId: (state, action) => {
      const { stockItemId, orderTrolleyProfileId } = action.payload;
      //check for index before proceeding
      const correctIndex = state.prescriptionItemToolTip.findIndex((tooltip) =>
        tooltip?.orderTooltipSummaryItemWithFlavours?.some(
          (item) => item.stockItemId === stockItemId,
        ),
      );

      if (correctIndex !== -1) {
        const items =
          state.prescriptionItemToolTip[correctIndex]
            .orderTooltipSummaryItemWithFlavours;
        const itemIndex = items.findIndex(
          (item) => item.stockItemId === stockItemId,
        );

        if (itemIndex !== -1 && items[itemIndex].currentOrderPad) {
          items[itemIndex].currentOrderPad.orderTrolleyProfileId =
            orderTrolleyProfileId;
        }
      }
    },

    updateLastOrderedQuantity: (state, action) => {
      state.lastOrderedQuantity = action?.payload;
    },
    setPatientTags: (state, action) => {
      state.patientTag = [...state.patientTag, action?.payload];
    },
    removePatientTagsData: (state, action) => {
      state.patientTag = action?.payload;
    },
    setIsDoseValueData: (state, action) => {
      state.doseValueTotalEmpty = action?.payload;
    },
    setDoseValueEmptyPrescribedItemIdData: (state, action) => {
      state.doseValueEmptyPrescribedItemId = action?.payload;
    },
    setKanbanFiltersData(state, action) {
      state.kanbanFilters = action.payload;
    },
    setIsNewPatientId: (state, action) => {
      state.newPatientId = action?.payload || "";
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getPrescriptionIncomingIdsData.pending, (state) => {
        state.isChecksLoading = true;
        state.incomingIds = [];
      })
      .addCase(getPrescriptionIncomingIdsData.fulfilled, (state, action) => {
        state.isChecksLoading = false;
        state.incomingIds = action?.payload || [];
        if (action?.payload.length === 0) {
          state.isPatient = false;
        } else {
          state.isPatient = true;
        }
      })
      .addCase(getPrescriptionIncomingIdsData.rejected, (state, action) => {
        logErrorWithPayload(action?.error);

        logErrorWithPayload(action?.error);
        state.isChecksLoading = false;
        state.incomingIds = [];
      })
      .addCase(getPrescriptionByIncomingIdData.pending, (state) => {
        state.isNmsPrescriptionLoading = true;
        state.prescriptions = [];
      })
      .addCase(getPrescriptionByIncomingIdData.fulfilled, (state, action) => {
        const appDataFromResponse = action?.payload;
        if (appDataFromResponse) {
          try {
            const { prescriptionGetModel, pharmacy } =
              appDataFromResponse || {};
            state.selectedBucketType = prescriptionGetModel?.bucketType;
            state.prescriptions = prescriptionGetModel;
            state.clinicalChecksPharmacy = pharmacy;
            const { patient } = prescriptionGetModel || {};
            state.patientTag = patient?.patientTags;
            state.patientName = `${patient?.title ?? ""} ${
              patient?.forename ?? ""
            } ${patient?.middleName ?? ""} ${patient?.surname ?? ""}`.trim();
            const {
              patientId,
              prescriptionItems,
              earliestDispenseDate,
              latestDispenseDate,
              prescriptionDate,
              prescriptionSourceType,
            } = prescriptionGetModel || {};
            state.isParked = patient.patientTags?.some((tag) =>
              tag.tagOptions?.some((o) => o.tagOptionType === 9),
            );
            const newPatId = state.newPatientId;
            state.patientId = patientId;
            state.isPatient = true;
            const MIN_DATE = "0001-01-01T00:00:00";

            const isValidDate = (date) =>
              moment(date).isValid() && date === MIN_DATE;
            if (prescriptionSourceType === 3 || prescriptionSourceType === 4) {
              const currentDate = moment();
              const scriptDate = moment(prescriptionDate);
              const isHasDispensingWindow = moment(scriptDate)
                .add(6, "months")
                .isBefore(currentDate);
              state.isHasDispensingWindow = isHasDispensingWindow;
            } else if (
              !isValidDate(earliestDispenseDate) ||
              !isValidDate(latestDispenseDate) ||
              moment(prescriptionDate).isBetween(
                earliestDispenseDate,
                latestDispenseDate,
                null,
                "[]",
              )
            ) {
              state.isHasDispensingWindow = false;
            } else {
              state.isHasDispensingWindow = true;
            }
            prescriptionGetModel?.notes?.forEach((value) => {
              if (value && value.archiveDate === null) {
                let createdDate = moment(value.createdOn).format(
                  "YYYY-MM-DD[T]HH:mm:ss.SSS[Z]",
                );
                state.clinicalChecksNotes = [
                  ...state.clinicalChecksNotes,
                  {
                    ...value,
                    createdOn: createdDate,
                  },
                ];
              }
            });
            // if (patientId) {
            //   state.isSkip = false;
            // } else {
            //   state.isSkip = true;
            // }
            prescriptionItems?.map((value) => {
              if (value?.notes?.length > 0) {
                state.notesModel = [
                  ...state.notesModel,
                  ...value.notes.filter((note) => note?.archiveDate === null),
                ];
              }
              if (
                value.prescribedItemId ===
                  "00000000-0000-0000-0000-000000000000" ||
                value.prescribedItemId === null
              ) {
                state.isMatched = true;
              } else {
                state.isMatched = false;
              }
              if (value?.dosageText === "" || value?.dosageText === null) {
                state.doseValueTotalEmpty += 1;
                state.doseValueEmptyPrescribedItemId.push(
                  value.prescriptionItemId,
                );
              }
            });

            state.checkNowModel = new setClinicalChecks(
              prescriptionGetModel,
              0,
              "",
              "",
              false,
              "",
              "",
              state.isParked,
              newPatId,
            );
          } catch (error) {
            logErrorWithPayload(error, action?.payload);
          }
        } else {
          state.isPatient = false;
        }
      })
      .addCase(getPrescriptionByIncomingIdData.rejected, (state, action) => {
        logErrorWithPayload(action?.error);
        state.prescriptions = [];
      })
      .addCase(getMedicationData.pending, (state) => {
        state.isChecksLoading = true;
        state.patientMedication = null;
      })
      .addCase(getMedicationData.fulfilled, (state, action) => {
        state.isChecksLoading = false;
        const appDataFromResponse = action?.payload;
        if (appDataFromResponse) {
          try {
            if (appDataFromResponse.patientMedications !== null) {
              appDataFromResponse.patientMedications.sort(function (a, b) {
                return a.prescribedItem.writtenAs.localeCompare(
                  b.prescribedItem.writtenAs.name,
                );
              });
              state.therapyComponents = appDataFromResponse?.therapyComponents;
              if (
                appDataFromResponse?.therapyComponents?.includes(4) ||
                appDataFromResponse?.therapyComponents?.includes(5)
              ) {
                state.isTherapy = true;
              }
              if (appDataFromResponse?.defaultDosageTimings?.length !== 0) {
                appDataFromResponse?.defaultDosageTimings?.sort(
                  function (a, b) {
                    return a.patientMedicationOrder - b.patientMedicationOrder;
                  },
                );

                state.defaultDosageTimings =
                  appDataFromResponse?.defaultDosageTimings;
              }
            }
          } catch (error) {
            logErrorWithPayload(error, action?.payload);
          }
        }

        state.patientMedication = appDataFromResponse;
      })
      .addCase(getMedicationData.rejected, (state, action) => {
        logErrorWithPayload(action?.error);
        state.isChecksLoading = false;
        state.patientMedication = null;
      })
      .addCase(getPrescriptionItemChecksData.pending, (state) => {
        state.isChecksLoading = true;
        state.prescriptionItemCheck = [];
      })
      .addCase(getPrescriptionItemChecksData.fulfilled, (state, action) => {
        state.isChecksLoading = false;
        state.openFindPatientModal = false;
        state.openFindPatientComparisonModal = false;
        const appDataFromResponse = action?.payload;

        const groupChecks = () => {
          try {
            const groupedPrescriptionChecks = {};
            const seenNonGroupableKeys = new Set();

            appDataFromResponse.forEach((item) => {
              const key = `${item.clinicalCheckId}-${item.canGroup}-${item.prescribedItemId}`;

              if (item.canGroup === false) {
                if (!seenNonGroupableKeys.has(key)) {
                  seenNonGroupableKeys.add(key);
                  groupedPrescriptionChecks[key] = [item]; // add once only
                }
                // else skip duplicate
              } else {
                if (!groupedPrescriptionChecks[key]) {
                  groupedPrescriptionChecks[key] = [];
                }
                groupedPrescriptionChecks[key].push(item);
              }
            });

            state.prescriptionCheckGroups = Object.values(
              groupedPrescriptionChecks,
            );
          } catch (error) {
            logErrorWithPayload(error, action?.payload);
          }
        };
        if (appDataFromResponse) {
          try {
            appDataFromResponse?.map((item) => {
              if (item.checkSeverity == 2) {
                state.severityCount += 1;
              } else {
                state.severityCount = 0;
              }

              // item.clinicalCheckOptions?.map((value) => {
              //   if (validationChecks.includes(value.clinicalCheckActionType)) {
              //     state.isAccess = true;
              //   } else {
              //     state.isAccess = false;
              //   }
              // });
            });
            groupChecks();
          } catch (error) {
            logErrorWithPayload(error, action?.payload);
          }
        }

        state.prescriptionItemCheck = appDataFromResponse;
      })
      .addCase(getPrescriptionItemChecksData.rejected, (state, action) => {
        logErrorWithPayload(action?.error);
        state.isChecksLoading = false;
        state.prescriptionItemCheck = [];
      })
      .addCase(getPrescriptionChecksData.pending, (state) => {
        state.isChecksLoading = true;
        state.prescriptionChecks = [];
      })
      .addCase(getPrescriptionChecksData.fulfilled, (state, action) => {
        state.isChecksLoading = false;
        state.openFindPatientModal = false;
        state.openFindPatientComparisonModal = false;
        state.prescriptionChecks = action?.payload || [];
      })
      .addCase(getPrescriptionChecksData.rejected, (state, action) => {
        logErrorWithPayload(action?.error);
        state.isChecksLoading = false;
        state.prescriptionChecks = [];
      })
      .addCase(getPostMedicationData.pending, (state) => {
        state.isChecksLoading = true;
        state.postMedication = [];
      })
      .addCase(getPostMedicationData.fulfilled, (state, action) => {
        state.isChecksLoading = false;
        const appDataFromResponse = action?.payload;
        if (appDataFromResponse) {
          try {
            state.postMedicationId = appDataFromResponse?.patientMedicationId;
          } catch (error) {
            logErrorWithPayload(error, action?.payload);
          }
        }
        state.postMedication = appDataFromResponse;
      })
      .addCase(getPostMedicationData.rejected, (state, action) => {
        logErrorWithPayload(action?.error);
        state.isChecksLoading = false;
        state.postMedication = [];
      })
      .addCase(getAdditionalEndorsementData.pending, (state) => {
        state.isChecksLoading = true;
        state.additionalEndorsement = [];
      })
      .addCase(getAdditionalEndorsementData.fulfilled, (state, action) => {
        state.isChecksLoading = false;
        state.additionalEndorsement = action?.payload || [];
        state.isEndorse = true;
      })
      .addCase(getAdditionalEndorsementData.rejected, (state, action) => {
        logErrorWithPayload(action?.error);
        state.isChecksLoading = false;
        state.additionalEndorsement = [];
      })
      .addCase(setPatientClinicalChecksData.pending, (state) => {
        state.isChecksLoading = true;
        state.clinicalChecksAdded = [];
      })
      .addCase(setPatientClinicalChecksData.fulfilled, (state, action) => {
        state.isChecksLoading = false;
        state.clinicalChecksAdded = action?.payload || [];
      })
      .addCase(setPatientClinicalChecksData.rejected, (state, action) => {
        logErrorWithPayload(action?.error);
        state.isChecksLoading = false;
        state.clinicalChecksAdded = [];
      })
      .addCase(getPatientImageData.pending, (state) => {
        state.isNmsPrescriptionLoading = true;
        state.isClinicalChecksImageLoading = true;
        state.patientImage = [];
      })
      .addCase(getPatientImageData.fulfilled, (state, action) => {
        state.isNmsPrescriptionLoading = false;
        state.isClinicalChecksImageLoading = false;
        state.patientImage = action?.payload || [];
      })
      .addCase(getPatientImageData.rejected, (state, action) => {
        logErrorWithPayload(action?.error);
        state.isNmsPrescriptionLoading = false;
        state.isClinicalChecksImageLoading = false;
        state.patientImage = [];
      })
      .addCase(setCCOrderItemToolTipData.pending, (state) => {
        state.isCCOrderTooltipLoading = true;
        state.CCOrderTooltipData = null;
        state.toolTipSummaryData = [];
      })
      .addCase(setCCOrderItemToolTipData.fulfilled, (state, action) => {
        state.isCCOrderTooltipLoading = false;
        const appDataFromResponse = action?.payload;

        if (appDataFromResponse) {
          try {
            state.prescriptionItemToolTip = [
              ...(state.prescriptionItemToolTip || []),
              ...(Array.isArray(appDataFromResponse)
                ? appDataFromResponse
                : [appDataFromResponse]),
            ];
            state.CCOrderTooltipData =
              appDataFromResponse?.stockItemTooltipSummary;
            state.toolTipSummaryData =
              appDataFromResponse?.orderTrolleyProfileModel;
          } catch (error) {
            logErrorWithPayload(error, action?.payload);
          }
        }
      })
      .addCase(setCCOrderItemToolTipData.rejected, (state, action) => {
        logErrorWithPayload(action?.error);
        state.isCCOrderTooltipLoading = false;
        state.prescriptionItemToolTip = [];
        state.CCOrderTooltipData = null;
        state.toolTipSummaryData = [];
      })
      .addCase(updateCCOrderItemToolTipData.pending, (state) => {
        state.updateCCOrderTooltipLoading = true;
      })
      .addCase(updateCCOrderItemToolTipData.fulfilled, (state, action) => {
        state.updateCCOrderTooltipLoading = false;
      })
      .addCase(updateCCOrderItemToolTipData.rejected, (state, action) => {
        logErrorWithPayload(action?.error);
        state.updateCCOrderTooltipLoading = false;
      })
      .addCase(updateItemToolTipFlavoursData.pending, (state) => {
        state.updateCCOrderTooltipLoading = true;
      })
      .addCase(updateItemToolTipFlavoursData.fulfilled, (state, action) => {
        state.updateCCOrderTooltipLoading = false;
      })
      .addCase(updateItemToolTipFlavoursData.rejected, (state, action) => {
        logErrorWithPayload(action?.error);
        state.updateCCOrderTooltipLoading = false;
      })
      .addCase(addpatientInTitanData.pending, (state) => {
        state.isPatientAddedInTitan = true;
      })
      .addCase(addpatientInTitanData.fulfilled, (state, action) => {
        state.isPatientAddedInTitan = action?.payload;
      })
      .addCase(addpatientInTitanData.rejected, (state, action) => {
        logErrorWithPayload(action?.error);
        state.isPatientAddedInTitan = false;
      })
      .addCase(getDrugUomFixValueData.pending, (state) => {
        state.isChecksLoading = true;
        state.prescribedItemInfoModel = null;
      })
      .addCase(getDrugUomFixValueData.fulfilled, (state, action) => {
        state.isChecksLoading = false;
        const appDataFromResponse = action?.payload;

        if (appDataFromResponse) {
          try {
            state.prescribedItemInfoModel = appDataFromResponse;
            if (state?.prescribedItemInfoModel != null) {
              state.uom = appDataFromResponse?.uom;
            }
          } catch (error) {
            logErrorWithPayload(error, action?.payload);
          }
        }
      })
      .addCase(getTitanPatientSearchData.pending, (state) => {
        state.patientSearchLoader = true;
      })
      .addCase(getTitanPatientSearchData.fulfilled, (state, action) => {
        state.patientSearchLoader = false;
        state.patientSearchItems = action?.payload;
      })
      .addCase(getTitanPatientSearchData.rejected, (state, action) => {
        logErrorWithPayload(action?.error);
        state.patientSearchLoader = false;
      })
      .addCase(addEmergencySuppliesData.pending, (state) => {
        state.emergencySupplies = [];
      })
      .addCase(addEmergencySuppliesData.fulfilled, (state, action) => {
        state.emergencySupplies = action?.payload || [];
      })
      .addCase(addEmergencySuppliesData.rejected, (state, action) => {
        logErrorWithPayload(action?.error);
        state.emergencySupplies = [];
      })
      .addCase(getKanbanInboxData.pending, (state) => {
        state.isCCKanbanLoading = true;
        state.kanbanInbox = [];
      })
      .addCase(getKanbanInboxData.fulfilled, (state, action) => {
        state.isCCKanbanLoading = false;
        state.kanbanInbox = action?.payload || [];
      })
      .addCase(getKanbanInboxData.rejected, (state, action) => {
        logErrorWithPayload(action?.error);
        state.isCCKanbanLoading = false;
        state.kanbanInbox = [];
      })
      .addCase(getKanbanCheckData.pending, (state) => {
        state.isCCKanbanLoading = true;
        state.KanbanChecks = [];
      })
      .addCase(getKanbanCheckData.fulfilled, (state, action) => {
        state.isCCKanbanLoading = false;
        const appDataFromResponse = action?.payload;
        state.KanbanChecks = action?.payload || [];
        const tagMap = new Map();
        appDataFromResponse.forEach((item) => {
          if (item?.patient?.patientTags?.length) {
            item.patient.patientTags.forEach((tag) => {
              if (tag?.tagName && !tagMap.has(tag.tagName)) {
                tagMap.set(tag.tagName, {
                  tagName: tag.tagName,
                  tagColour: tag.tagColour,
                });
              }
            });
          }
        });
        const distinctTag = Array.from(tagMap.values());
        state.patientTagsColor = distinctTag;
        const distinctTagNames = [
          ...new Set(
            appDataFromResponse.flatMap((item) =>
              item.patient.patientTags.map((tag) => tag.tagName),
            ),
          ),
        ].sort((a, b) => a.localeCompare(b));
        state.checksTagsfilters = distinctTagNames;
      })
      .addCase(getKanbanCheckData.rejected, (state, action) => {
        logErrorWithPayload(action?.error);
        state.isCCKanbanLoading = false;
        state.KanbanChecks = [];
      })
      .addCase(getTitanPatientByPatientIdData.rejected, (state, action) => {
        state.isChecksLoading = false;
        state.patientData = null;
      })
      .addCase(getTitanPatientByPatientIdData.pending, (state) => {
        state.isChecksLoading = true;
      })
      .addCase(getTitanPatientByPatientIdData.fulfilled, (state, action) => {
        state.isChecksLoading = false;
        const appDataFromResponse = action?.payload;
        try {
          state.patientData = appDataFromResponse || null;
        } catch (error) {}
      })
      .addCase(getClinicalChecksTagsData.pending, (state, action) => {})
      .addCase(getClinicalChecksTagsData.fulfilled, (state, action) => {
        state.clinicalChecksTags = action?.payload || [];
      })
      .addCase(getClinicalChecksTagsData.rejected, (state, action) => {})
      .addCase(lockedPrescriptionsData.pending, (state) => {
        state.isChecksLoading = true;
        state.lockedPrescriptions = [];
      })
      .addCase(lockedPrescriptionsData.fulfilled, (state, action) => {
        state.isChecksLoading = false;
        state.lockedPrescriptions = action?.payload || [];
      })
      .addCase(lockedPrescriptionsData.rejected, (state, action) => {
        logErrorWithPayload(action?.error);
        state.isChecksLoading = false;
        state.lockedPrescriptions = [];
      })
      .addCase(setPatientTagsData.pending, (state, action) => {
        state.isTagsLoading = true;
      })
      .addCase(setPatientTagsData.fulfilled, (state, action) => {
        state.isTagsLoading = false;
      })
      .addCase(setPatientTagsData.rejected, (state, action) => {
        state.isTagsLoading = false;
      })
      .addCase(deletePatientTagData.pending, (state, action) => {
        state.isTagsLoading = true;
      })
      .addCase(deletePatientTagData.fulfilled, (state, action) => {
        state.isTagsLoading = false;
      })
      .addCase(deletePatientTagData.rejected, (state, action) => {
        state.isTagsLoading = false;
      })
      .addCase(getPatientHistoryData.pending, (state, action) => {
        state.isHistoryLoading = true;
        state.patientHistory = [];
      })
      .addCase(getPatientHistoryData.fulfilled, (state, action) => {
        state.isHistoryLoading = false;
        state.patientHistory = action?.payload || [];
      })
      .addCase(getPatientHistoryData.rejected, (state, action) => {
        state.isHistoryLoading = false;
        state.patientHistory = [];
      })
      .addCase(getPatientLastDosageData.pending, (state, action) => {
        state.isLastDosageLoading = true;
      })
      .addCase(getPatientLastDosageData.fulfilled, (state, action) => {
        state.isLastDosageLoading = false;
      })
      .addCase(getPatientLastDosageData.rejected, (state, action) => {
        state.isLastDosageLoading = false;
      });
  },
});

export const {
  incomingId,
  setIsClinicalChecksLoading,
  setIsNmsPrescriptionLoading,
  setIsSkip,
  setIsMatched,
  setIsAccess,
  setIsEndorse,
  setIsCheckNowModel,
  setIsItemchecks,
  setIsSeverityCount,
  setIsMandatory,
  setIsDispenseArray,
  setClinicalChecksNotes,
  setIsTheraphy,
  setIsItemReturnDose,
  setIsItemReturnQuantity,
  setIsReturnQuantity,
  setIsReturnDose,
  setIsReturnDispense,
  setIsReturnStartDate,
  setIsReturnStopDate,
  setIsReturnMarking,
  setIsReturnTherapy,
  setIsReturnArchive,
  setIsReturnColor,
  setIsReturnPreparation,
  setIsReturnReport,
  setIsDispense,
  setIsEditable,
  setIsButtonclass,
  setIsNotesModel,
  setIsClinicalHeaderNotesModel,
  setMedicationTimeModel,
  setIsMedicineWarning,
  setIsPatientImage,
  setIsMedicationId,
  setIsParkedData,
  setSelectedBucketTypeData,
  setIsTheraphyModal,
  setTherapyModelContent,
  setOpenFindPatientModalData,
  setOpenFindPatientComparisonModalData,
  setCCModalOpenData,
  setCCModalLoaderData,
  setPrescriptionItemToolTip,
  setIsCCKanbanLoadingData,
  setIsCheckedClinicalId,
  updateFlavourQuantity,
  setPatientDataData,
  updateFlavourOrderTrolleyProfileId,
  updateLastOrderedQuantity,
  setFilterNamevalues,
  setKanbanInbox,
  setKanbanChecks,
  setPatientTags,
  setIsAcceptedData,
  setisHasDispensingWindow,
  setIsClinicalChecksPatientTags,
  setClinicalCheckPositionData,
  setClinicalCheckStatusData,
  removePatientTagsData,
  setShowNoPatientInTitanPopupData,
  setIsPatientData,
  setPatientHistory,
  setIsDoseValueData,
  setDoseValueEmptyPrescribedItemIdData,
  setKanbanFiltersData,
  setIsNewPatientId,
} = clinicalChecksSlice.actions;

export default clinicalChecksSlice.reducer;
